import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "file-preview-inline"
};
const _hoisted_2 = ["title"];
const _hoisted_3 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_4 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_5 = {
  key: 1,
  class: "space-y-2"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "file-att-main"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "file-att-meta"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1,
  class: "meta-sep"
};
const _hoisted_12 = {
  key: 2,
  class: "meta-preview"
};
const _hoisted_13 = {
  key: 3,
  class: "meta-download"
};
const _hoisted_14 = ["title", "onClick"];
const _hoisted_15 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_16 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_17 = ["disabled", "title", "onClick"];
import { ref, computed } from 'vue';
import FileIcon from './FileIcon.vue';
import FilePreviewModal from './FilePreviewModal.vue';
import { getFileName, getFileSize, getFileUrl, isPreviewable } from '@/utils/fileType';
export default {
  __name: 'FileAttachment',
  props: {
    // 数组或单值
    files: {
      type: [Array, Object, String],
      default: () => []
    },
    // 是否允许点击预览（false 时仅展示，无点击行为）
    previewable: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'list'
    },
    loader: {
      type: Function,
      default: null
    },
    // 布尔：整体开关；函数：逐文件判定（如按上传人归属显隐删除按钮）
    removable: {
      type: [Boolean, Function],
      default: false
    },
    removingId: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['remove'],
  setup(__props) {
    const props = __props;
    const previewVisible = ref(false);
    const currentIndex = ref(0);
    const fileList = computed(() => {
      if (!props.files) return [];
      if (Array.isArray(props.files)) return props.files;
      return [props.files];
    });
    const currentFile = computed(() => fileList.value[currentIndex.value] || null);
    function isClickable(file) {
      return props.previewable && hasPreviewSource(file);
    }
    function hasPreviewSource(file) {
      return Boolean(getFileUrl(file) || props.loader && typeof file === 'object' && file.previewMode === 'blob');
    }
    function onItemClick(file, idx) {
      if (!props.previewable) return;
      if (!hasPreviewSource(file)) return;
      if (isPreviewable(file)) {
        currentIndex.value = idx;
        previewVisible.value = true;
      } else {
        downloadFile(file);
      }
    }
    function isRemovable(file) {
      if (typeof props.removable === 'function') return Boolean(props.removable(file));
      return props.removable;
    }
    function isRemoving(file) {
      if (props.removingId == null) return false;
      const id = getFileIdentity(file);
      return id != null && String(id) === String(props.removingId);
    }
    function getFileIdentity(file) {
      if (!file || typeof file === 'string') return null;
      return file.attachmentId ?? file.id ?? file.fileKey ?? file.url ?? null;
    }
    function goPrev() {
      if (currentIndex.value > 0) currentIndex.value--;
    }
    function goNext() {
      if (currentIndex.value < fileList.value.length - 1) currentIndex.value++;
    }
    async function downloadFile(file) {
      if (props.loader && typeof file === 'object' && file.previewMode === 'blob') {
        const result = await props.loader(file, {
          purpose: 'download'
        });
        const payload = result?.data ?? result;
        if (payload instanceof Blob) {
          const blobUrl = URL.createObjectURL(payload);
          triggerDownload(blobUrl, getFileName(file));
          setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
          return;
        }
        if (typeof payload === 'string') {
          triggerDownload(payload, getFileName(file));
          return;
        }
      }
      triggerDownload(getDownloadSource(file) || getFileUrl(file), getFileName(file));
    }
    function getDownloadSource(file) {
      if (!file || typeof file === 'string') return '';
      return file.downloadSource || file.downloadUrl || '';
    }
    function triggerDownload(url, name) {
      if (!url) return;
      const a = document.createElement('a');
      a.href = url;
      a.download = name || '';
      a.target = '_blank';
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    return (_ctx, _cache) => {
      return __props.variant === 'button' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [currentFile.value && hasPreviewSource(currentFile.value) ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "file-preview-button",
        title: _unref(isPreviewable)(currentFile.value) ? '预览' : '下载查看',
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => onItemClick(currentFile.value, currentIndex.value), ["stop"]))
      }, [_unref(isPreviewable)(currentFile.value) ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[3] || (_cache[3] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      }, null, -1), _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[4] || (_cache[4] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
      }, null, -1)]))])), _createElementVNode("span", null, _toDisplayString(_unref(isPreviewable)(currentFile.value) ? '预览' : '下载查看'), 1)], 8, _hoisted_2)) : _createCommentVNode("", true), _createVNode(FilePreviewModal, {
        modelValue: previewVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => previewVisible.value = $event),
        file: currentFile.value,
        loader: __props.loader,
        "show-prev": fileList.value.length > 1 && currentIndex.value > 0,
        "show-next": fileList.value.length > 1 && currentIndex.value < fileList.value.length - 1,
        onPrev: goPrev,
        onNext: goNext
      }, null, 8, ["modelValue", "file", "loader", "show-prev", "show-next"])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: file.fileKey || file.url || idx,
          class: _normalizeClass(["file-att-item", {
            'is-clickable': isClickable(file)
          }]),
          onClick: $event => onItemClick(file, idx)
        }, [_createVNode(FileIcon, {
          file: file,
          thumb: true,
          class: "w-9 h-9 shrink-0"
        }, null, 8, ["file"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
          class: "file-att-name",
          title: _unref(getFileName)(file)
        }, _toDisplayString(_unref(getFileName)(file)), 9, _hoisted_8), _createElementVNode("div", _hoisted_9, [_unref(getFileSize)(file) ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(getFileSize)(file)), 1)) : _createCommentVNode("", true), _unref(getFileSize)(file) && _unref(isPreviewable)(file) ? (_openBlock(), _createElementBlock("span", _hoisted_11, "·")) : _createCommentVNode("", true), _unref(isPreviewable)(file) ? (_openBlock(), _createElementBlock("span", _hoisted_12, "可预览")) : (_openBlock(), _createElementBlock("span", _hoisted_13, "下载查看"))])]), hasPreviewSource(file) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "file-att-action",
          title: _unref(isPreviewable)(file) ? '预览' : '下载',
          onClick: _withModifiers($event => onItemClick(file, idx), ["stop"])
        }, [_unref(isPreviewable)(file) ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[5] || (_cache[5] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        }, null, -1), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[6] || (_cache[6] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
        }, null, -1)]))]))], 8, _hoisted_14)) : _createCommentVNode("", true), isRemovable(file) ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "file-att-remove",
          disabled: isRemoving(file),
          title: isRemoving(file) ? '删除中' : '删除',
          onClick: _withModifiers($event => _ctx.$emit('remove', file), ["stop"])
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m-7 0a1 1 0 011-1h6a1 1 0 011 1m-8 0h8"
        })], -1)]))], 8, _hoisted_17)) : _createCommentVNode("", true)], 10, _hoisted_6);
      }), 128)), _createVNode(FilePreviewModal, {
        modelValue: previewVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => previewVisible.value = $event),
        file: currentFile.value,
        loader: __props.loader,
        "show-prev": fileList.value.length > 1 && currentIndex.value > 0,
        "show-next": fileList.value.length > 1 && currentIndex.value < fileList.value.length - 1,
        onPrev: goPrev,
        onNext: goNext
      }, null, 8, ["modelValue", "file", "loader", "show-prev", "show-next"])]));
    };
  }
};